<div class="category-home">
  <div class="category-container">
    <h1>{{groupName}} Wellbeing Services</h1>
    <div class="cat-list">
      <ng-container *ngFor="let category of categoryGroups">
        <a class="cat-item" [routerLink]="['/category/' + category.slug]">
          <img class="cat-image" src="assets/images/category/{{category.name}}.jpg" alt="">
          <p class="cat-name">{{category.name}}</p>
        </a>
      </ng-container>
    </div>
  </div>
</div>